import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useLocales } from '@/locales';
import { Eye, EyeOff, Mail } from 'lucide-react';

const AdminCredentials = memo(
  ({ credentials, errors, onChange, onTogglePasswordVisibility }) => {
    const { translate } = useLocales();

    return (
      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="admin-email">{translate('Your_login')}</Label>
          <div className="relative">
            <Input
              id="admin-email"
              type="email"
              placeholder={translate('Enter_login')}
              name="login"
              className="pr-10"
              value={credentials.email}
              onChange={onChange('email')}
              autoComplete="email"
              aria-invalid={errors.email}
            />
            <Mail className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="admin-password">{translate('Password')}</Label>
          <div className="relative">
            <Input
              id="admin-password"
              type={credentials.showPassword ? 'text' : 'password'}
              placeholder={translate('Password')}
              className="pr-10"
              value={credentials.password}
              onChange={onChange('password')}
              autoComplete="current-password"
              aria-invalid={errors.password}
            />
            <Button
              variant="ghost"
              size="icon"
              className="absolute right-0 top-0 h-full px-3 hover:bg-transparent"
              aria-label={translate('Toggle password visibility')}
              onClick={onTogglePasswordVisibility}
              type="button"
            >
              {credentials.showPassword ? (
                <EyeOff className="h-4 w-4 text-muted-foreground" />
              ) : (
                <Eye className="h-4 w-4 text-muted-foreground" />
              )}
            </Button>
          </div>
        </div>
      </div>
    );
  },
);

AdminCredentials.displayName = 'AdminCredentials';

AdminCredentials.propTypes = {
  credentials: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
    showPassword: PropTypes.bool,
  }).isRequired,
  errors: PropTypes.shape({
    email: PropTypes.bool,
    password: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onTogglePasswordVisibility: PropTypes.func.isRequired,
};

export default AdminCredentials;
